module.exports = __webpack_public_path__ + "media/images/icons/outlined/shopping-222f65291f2a5b8b077499f2216d2faf.svg";